var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-summary',{attrs:{"isHeader":false,"isFooter":false}},[_c('div',{staticClass:"c-base-summary__wrapper"},[_c('p',[_vm._v(_vm._s(_vm.reason))])])]),_c('router-link',{staticClass:"button is-black is-outlined is-big margin-bottom",attrs:{"to":{ name: 'carteira' }}},[_vm._v(" Ok, entendi! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }